<script>
import { ref, onMounted, inject } from 'vue'
import redeMarketingApi from '@/services/api/redeMarketingRepository'

export default {
  setup() {
    const swal = inject('$swal')
    const loading = ref(true)
    const salvando = ref(false)
    const config = ref({})

    onMounted(async () => {
      try {
        const resp = await redeMarketingApi.ObterConfiguracao()
        config.value = resp.data
      } catch (e) {
        swal({ icon: 'error', title: 'Erro', text: e.response?.data?.message || e.message })
      } finally {
        loading.value = false
      }
    })

    async function salvar() {
      salvando.value = true
      try {
        const resp = await redeMarketingApi.AtualizarConfiguracao(config.value)
        config.value = resp.data
        swal({ icon: 'success', title: 'Salvo', text: 'Configuração atualizada.' })
      } catch (e) {
        swal({ icon: 'error', title: 'Erro', text: e.response?.data?.message || e.message })
      } finally {
        salvando.value = false
      }
    }

    return { loading, salvando, config, salvar }
  },
}
</script>

<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
      <div class="d-flex align-items-center gap-2">
        <router-link to="/rede-marketing" class="btn btn-sm btn-light">
          <i class="material-icons align-middle">arrow_back</i>
        </router-link>
        <h3 class="mb-0">Configuração da Rede</h3>
      </div>
      <router-link to="/rede-marketing/configuracao/ranks" class="btn btn-sm btn-outline-warning d-flex align-items-center">
        <i class="material-icons me-1" style="font-size: 18px;">military_tech</i>
        Configurar Ranks
      </router-link>
    </div>

    <div v-if="loading" class="text-center py-5">
      <div class="spinner-border text-primary"></div>
    </div>

    <form v-else @submit.prevent="salvar">
      <!-- Bônus ativos -->
      <div class="card mb-3">
        <div class="card-header pb-2">
          <h5 class="mb-0"><i class="material-icons align-middle me-1">toggle_on</i> Bônus Ativos</h5>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-6">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="sw1" v-model="config.bonusIndicacaoDiretaAtivo" />
                <label class="form-check-label" for="sw1">
                  <strong>Bônus de Indicação Direta</strong> (Fast Start)
                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="sw2" v-model="config.bonusEquipeVolumeAtivo" />
                <label class="form-check-label" for="sw2">
                  <strong>Bônus de Equipe/Volume</strong>
                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="sw3" v-model="config.bonusMatchingAtivo" />
                <label class="form-check-label" for="sw3">
                  Bônus Matching (espelho do ganho do indicado)
                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="sw4" v-model="config.bonusLiderancaAtivo" />
                <label class="form-check-label" for="sw4">
                  Bônus de Liderança (pool)
                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="sw5" v-model="config.bonusAvancoRankAtivo" />
                <label class="form-check-label" for="sw5">
                  Bônus de Avanço de Rank
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Plano de compensação -->
      <div class="card mb-3">
        <div class="card-header pb-2">
          <h5 class="mb-0"><i class="material-icons align-middle me-1">account_tree</i> Plano de Compensação</h5>
        </div>
        <div class="card-body">
          <div class="form-check form-switch mb-3">
            <input class="form-check-input" type="checkbox" id="sw-binario" v-model="config.planoBinarioAtivo" />
            <label class="form-check-label" for="sw-binario">
              Plano Binário Ativo (além do Unilevel)
            </label>
          </div>
          <label class="form-label small">Profundidade máxima (níveis)</label>
          <input type="number" min="1" max="20" class="form-control form-control-sm"
                 style="max-width: 120px;" v-model.number="config.profundidadeMaximaNiveis" />
        </div>
      </div>

      <!-- Limites globais -->
      <div class="card mb-3">
        <div class="card-header pb-2">
          <h5 class="mb-0"><i class="material-icons align-middle me-1">tune</i> Limites Globais</h5>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label small">% máximo do faturamento em comissões</label>
              <div class="input-group input-group-sm">
                <input type="number" step="0.01" min="0" max="1" class="form-control"
                       v-model.number="config.percentualMaximoFaturamento" />
                <span class="input-group-text">(ex: 0.35 = 35%)</span>
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label small">Valor mínimo para saque</label>
              <div class="input-group input-group-sm">
                <span class="input-group-text">R$</span>
                <input type="number" step="0.01" min="0" class="form-control"
                       v-model.number="config.valorMinimoSaque" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Ações -->
      <div class="d-flex justify-content-end">
        <button type="submit" class="btn btn-success d-flex align-items-center" :disabled="salvando">
          <i class="material-icons me-1" style="font-size: 18px;">save</i>
          {{ salvando ? 'Salvando...' : 'Salvar Configuração' }}
        </button>
      </div>
    </form>
  </div>
</template>
